import api from '../../../lib/api';
import type {
  ImplementationGuideDetail,
  ImplementationSummary,
  OrganizationItemContextView,
  SyncAutoProgressResult,
  TaskWithProgressView,
  UpdateTaskProgressPayload,
  UpsertOrganizationContextPayload,
} from './types';

export const fetchImplementationSummary = async (
  standard = 'iso9001',
): Promise<ImplementationSummary> => {
  const { data } = await api.get<ImplementationSummary>(`iso-implementation/${standard}/summary`);
  return data;
};

export const fetchImplementationGuide = async (
  slug: string,
  standard = 'iso9001',
): Promise<ImplementationGuideDetail> => {
  const { data } = await api.get<ImplementationGuideDetail>(
    `iso-implementation/${standard}/guides/${slug}`,
  );
  return data;
};

export const fetchImplementationGuideFull = async (
  slug: string,
  standard = 'iso9001',
): Promise<ImplementationGuideDetail> => {
  const { data } = await api.get<ImplementationGuideDetail>(
    `iso-implementation/${standard}/guides/${slug}/full`,
  );
  return data;
};

export const upsertOrganizationContext = async (
  catalogItemId: string,
  payload: UpsertOrganizationContextPayload,
): Promise<OrganizationItemContextView> => {
  const { data } = await api.put<OrganizationItemContextView>(
    `iso-implementation/organization-context/${catalogItemId}`,
    payload,
  );
  return data;
};

export const fetchImplementationTasks = async (
  standard = 'iso9001',
  guideSlug?: string,
): Promise<TaskWithProgressView[]> => {
  const { data } = await api.get<{ items: TaskWithProgressView[]; total: number }>(
    `iso-implementation/${standard}/tasks`,
    { params: guideSlug ? { guideSlug } : undefined },
  );
  return data.items;
};

export const patchTaskProgress = async (
  taskId: string,
  payload: UpdateTaskProgressPayload,
): Promise<TaskWithProgressView> => {
  const { data } = await api.patch<TaskWithProgressView>(
    `iso-implementation/tasks/${taskId}/progress`,
    payload,
  );
  return data;
};

export const syncImplementationProgress = async (
  standard = 'iso9001',
): Promise<SyncAutoProgressResult> => {
  const { data } = await api.post<SyncAutoProgressResult>(
    `iso-implementation/${standard}/sync`,
  );
  return data;
};
